import { Tooltip, tokens } from "@fluentui/react-components";
import { CSSProperties, MouseEvent } from "react";

interface LabelWithInfoIconProps {
  label?: string;
  info: string;
}

const rootStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  columnGap: "6px",
  maxWidth: "100%",
};

const iconStyle: CSSProperties = {
  cursor: "help",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  width: "14px",
  height: "14px",
  minWidth: "14px",
  minHeight: "14px",
  borderRadius: "50%",
  border: `1px solid ${tokens.colorNeutralForeground3}`,
  color: tokens.colorNeutralForeground3,
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: 1,
  boxSizing: "border-box",
  flexShrink: 0,
};

export default function LabelWithInfoIcon({ label, info }: LabelWithInfoIconProps) {
  const handleIconClick = (event: MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const icon = (
    <Tooltip relationship="description" content={info}>
      <span
        style={iconStyle}
        aria-label={label ? `Informacja: ${label}` : "Informacja"}
        onClick={handleIconClick}
      >
        i
      </span>
    </Tooltip>
  );

  if (!label) {
    return icon;
  }

  return (
    <span style={rootStyle}>
      <span>{label}</span>
      {icon}
    </span>
  );
}
